import { Checkbox, CheckboxProps, styled } from "@mui/material";

import { themePalette } from "../../../theme";

const PhlebotomyCheckbox = styled(Checkbox)<CheckboxProps>({
  color: themePalette.neutral600,
  "&.Mui-checked, &.MuiCheckbox-indeterminate": {
    color: themePalette.redMedium,
  },
  "&:hover": {
    backgroundColor: "rgba(240, 96, 75, 0.08)",
  },
  "&.Mui-focusVisible": {
    outline: `2px solid ${themePalette.redDark}`,
    outlineOffset: 2,
  },
});

export default PhlebotomyCheckbox;
